interface SkeletonGridProps {
  count?: number;
  columns?: string;
}

export function CardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="skeleton-shimmer aspect-[4/3] w-full" />
      <div className="space-y-3 p-4 md:p-5">
        <div className="skeleton-shimmer h-4 w-3/4 rounded" />
        <div className="skeleton-shimmer h-3 w-full rounded" />
        <div className="skeleton-shimmer h-3 w-2/3 rounded" />
        <div className="skeleton-shimmer h-3 w-1/3 rounded" />
      </div>
    </div>
  );
}

export default function SkeletonGrid({ count = 6, columns = "sm:grid-cols-2 lg:grid-cols-3" }: SkeletonGridProps) {
  return (
    <div className={`grid grid-cols-1 gap-5 ${columns}`}>
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  );
}